import type { Transition, TargetAndTransition } from "framer-motion";
import { alpha } from "@mui/material";
import type { Theme } from "@mui/material/styles";

/* ---------- Floating tech icons ---------- */
export const floatIcon1Animate: TargetAndTransition = {
  y: [0, -15, 0],
  rotate: [0, 5, 0],
  scale: [1, 1.1, 1],
};
export const floatIcon1Transition: Transition = {
  duration: 6,
  repeat: Infinity,
  ease: "easeInOut",
};

export const floatIcon2Animate: TargetAndTransition = {
  y: [0, 15, 0],
  rotate: [0, -5, 0],
  scale: [1, 1.1, 1],
};
export const floatIcon2Transition: Transition = {
  duration: 7,
  repeat: Infinity,
  ease: "easeInOut",
  delay: 1,
};

export const floatIcon3Animate: TargetAndTransition = {
  y: [0, 10, 0],
  x: [0, 5, 0],
  scale: [1, 1.08, 1],
};
export const floatIcon3Transition: Transition = {
  duration: 8,
  repeat: Infinity,
  ease: "easeInOut",
  delay: 2,
};

export const floatIcon4Animate: TargetAndTransition = {
  y: [0, -8, 0],
  x: [0, -5, 0],
  scale: [1, 1.05, 1],
};
export const floatIcon4Transition: Transition = {
  duration: 5,
  repeat: Infinity,
  ease: "easeInOut",
  delay: 1.5,
};

/* ---------- Content entrance ---------- */
export const contentContainerInitial: TargetAndTransition = {
  opacity: 0,
  y: 20,
};
export const contentContainerInView: TargetAndTransition = {
  opacity: 1,
  y: 0,
};
export const contentContainerTransition: Transition = {
  duration: 0.5,
};

export const heroHeadingTransition: Transition = {
  duration: 0.7,
};

export const heroBodyTransition: Transition = {
  duration: 0.5,
  delay: 0.1,
};

export const buttonHover: TargetAndTransition = { scale: 1.05 };
export const buttonTap: TargetAndTransition = { scale: 0.95 };

/* ---------- Visual container ---------- */
export const visualContainerInitial: TargetAndTransition = {
  opacity: 0,
  scale: 0.9,
};
export const visualContainerInView: TargetAndTransition = {
  opacity: 1,
  scale: 1,
};
export const visualContainerTransition: Transition = {
  duration: 0.5,
  delay: 0.2,
};

/* ---------- Orbital rings ---------- */
export const outerRingAnimate: TargetAndTransition = { rotate: [0, 360] };
export const outerRingTransition: Transition = {
  duration: 45,
  repeat: Infinity,
  ease: "linear",
};

export const innerRingAnimate: TargetAndTransition = { rotate: [360, 0] };
export const innerRingTransition: Transition = {
  duration: 30,
  repeat: Infinity,
  ease: "linear",
};

export const ringDotTransition: Transition = {
  duration: 4,
  repeat: Infinity,
  ease: "easeInOut",
  delay: 1,
};

export const outerRingDotAnimate = (theme: Theme): TargetAndTransition => ({
  boxShadow: [
    `0 0 10px ${alpha(theme.palette.primary.main, 0.7)}`,
    `0 0 20px ${alpha(theme.palette.primary.main, 0.9)}`,
    `0 0 10px ${alpha(theme.palette.primary.main, 0.7)}`,
  ],
});

export const innerRingDotAnimate = (theme: Theme): TargetAndTransition => ({
  boxShadow: [
    `0 0 10px ${alpha(theme.palette.secondary.main, 0.7)}`,
    `0 0 20px ${alpha(theme.palette.secondary.main, 0.9)}`,
    `0 0 10px ${alpha(theme.palette.secondary.main, 0.7)}`,
  ],
});

/* ---------- Center card ---------- */
export const centerCardAnimate: TargetAndTransition = {
  rotate: [0, 2, 0, -2, 0],
  scale: [1, 1.03, 1, 1.03, 1],
};
export const centerCardTransition: Transition = {
  duration: 8,
  repeat: Infinity,
  ease: "easeInOut",
};

export const cursorAnimate: TargetAndTransition = {
  opacity: [0.9, 0, 0.9],
};
export const cursorTransition: Transition = {
  duration: 1.2,
  repeat: Infinity,
  ease: "easeInOut",
};

/* ---------- Connection lines ---------- */
export const connectionLineAnimate: TargetAndTransition = {
  opacity: [0.7, 1, 0.7],
  width: ["45%", "48%", "45%"],
};
export const connectionLineTransition: Transition = {
  duration: 3,
  repeat: Infinity,
  ease: "easeInOut",
};
export const connectionLine2Transition: Transition = {
  duration: 3,
  repeat: Infinity,
  ease: "easeInOut",
  delay: 1.5,
};
